// extracted by mini-css-extract-plugin
export default {"notice":"PublicTreeNotice_notice__-WdL1","title":"PublicTreeNotice_title__iuWwc","link":"PublicTreeNotice_link__WYq07"};